import React from "react";

interface MailAttachmentProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

function MailAttachmentIcon({ size = 24, className, ...props }: MailAttachmentProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <defs>
        <clipPath id="mail-clip">
          <polygon points="0,0 26,0 26,14 14,14 14,26 0,26" />
        </clipPath>
      </defs>
      <g clipPath="url(#mail-clip)">
        <rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <g transform="translate(0.5, 2)">
        <path d="M21 14v4c0 1.1-.9 2-2 2s-2-.9-2-2v-4.5c0-.28.22-.5.5-.5s.5.22.5.5V18h2v-4.5a2.5 2.5 0 0 0-5 0V18c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2z" fill="currentColor" />
      </g>
    </svg>
  );
}

export { MailAttachmentIcon };
